import { handleAction } from 'redux-actions';

import * as actions from '../actions';

const InitialState = '';

export const userEmailReducer = handleAction(
  actions.setUserEmail,
  (state, { payload: token }) => token,
  InitialState
);
